import axios from 'axios';

import {
    API_BASE_URL
} from '../../constants/index';
import ComplianceMonitoringService from './compliance/monitoring/MonitoringService';
import ComplianceScreeningService from './compliance/screening/ScreeningService';

const COMPLIANCE_EXPORT_PAGE_SIZE = 500;

export default class SupplierExportService {
	static instance;

	static getInstance() {
		if (!SupplierExportService.instance) {
			SupplierExportService.instance = new SupplierExportService();
		}

		return SupplierExportService.instance;
	}

    async fetchExportData(supplierId, params = {}){
        const complianceParams = {
            pageIndex: 1,
            pageSize: COMPLIANCE_EXPORT_PAGE_SIZE,
            ...params,
        };

        const monitoringService = ComplianceMonitoringService.getInstance();
        const screeningService = ComplianceScreeningService.getInstance();

        const [reportResponse, complianceMonitoring, complianceScreening] = await Promise.all([
            axios.get(`${API_BASE_URL}/supplier/${supplierId}/download_report`, {
                params,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`,
                },
            }),
            monitoringService.fetchSupplierComplianceMonitoringResult(supplierId, complianceParams)
                .catch(() => ({ follow_list_results: [] })),
            screeningService.fetchComplianceScreeningResult(supplierId, complianceParams)
                .catch(() => ({ result: [] })),
        ]);

        return {
            ...(reportResponse.data?.data || {}),
            complianceMonitoring,
            complianceScreening,
        };
    }
}
